export const BUY_POSITION_TYPE = 0;
export const SELL_POSITION_TYPE = 1;
export const BUY_POSITION_LABEL = 'C';
export const SELL_POSITION_LABEL = 'V';
export const POSITION_TYPE = [BUY_POSITION_TYPE, SELL_POSITION_TYPE];
export const POSITION_LABEL = [BUY_POSITION_LABEL, SELL_POSITION_LABEL];
export const POSITION_TYPE_VALUES = new Map([
    [BUY_POSITION_TYPE, BUY_POSITION_LABEL],
    [SELL_POSITION_TYPE, SELL_POSITION_LABEL]
]);
